import { apiClient } from '../../api/axiosClient'; 
// 1. Strictly define the request body matching your API schema
export interface SubscriptionRequest {
  email: string;
  type: 'waitlist' | 'newsletter'; 
}

// 2. Define the return outcome structure for your app logic
export interface SubscriptionResult {
  statusCode: number;
  isNewSubscription: boolean;
  message: string;
}

/**
 * Sends a POST request to create or re-activate a subscription.
 * According to API doc: Returns 201 for a new subscription, 200 if already existed.
 */
export const createSubscription = async (payload: SubscriptionRequest): Promise<SubscriptionResult> => {
  try {
    const response = await apiClient.post('subscriptions', payload);
    const status = response.status;

    return {
      statusCode: status,
      isNewSubscription: status === 201,
      message: status === 201 
        ? 'Successfully subscribed! Confirmation email sent.' 
        : 'You are already subscribed.'
    };
  } catch (error) {
    // Re-throw to handle failures explicitly in your controllers/routes
    throw error;
  }
};